export default __webpack_public_path__ + "static/media/close-circled.4540fdbc.svg";